import type { ReactNode, HTMLAttributes } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  hover?: boolean
}

export function Card({ children, hover, className = '', ...rest }: CardProps) {
  return (
    <div className={`card ${hover ? 'card-hover' : ''} ${className}`} {...rest}>
      {children}
    </div>
  )
}

export function CardHeader({ eyebrow, title, action }: { eyebrow?: string; title?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between mb-3">
      <div>
        {eyebrow && <div className="text-[12px] font-semibold text-ink-500 uppercase tracking-wider">{eyebrow}</div>}
        {title && <div className="text-[15px] font-semibold mt-0.5">{title}</div>}
      </div>
      {action}
    </div>
  )
}
